<template>
  <div>
    <v-container
      dense
      class="mt-9"
      v-if="loading"
      alig="center"
      justify="center"
    >
      <div>
        <v-row dense>
          <v-row dense class="mt-9">
            <v-row dense>
              <v-col>
                <v-card
                  elevation="0"
                  style="
                    border-radius: 10px;
                    position: relative;
                    overflow: visible;
                    background-color: transparent;
                  "
                >
                  <v-card-text style="background-color: transparent">
                    <v-row>
                      <v-col
                        ><strong style="font-size: 2rem; color: #b951e7"
                          >👋 Hi, {{ customerName }}! All good ?</strong
                        ></v-col
                      >
                    </v-row>
                    <v-row dense style="padding: 2vh">
                      <v-col>
                        <v-img
                          contain
                          width="15vw"
                          src="@/assets/images/dashboard/receita.png"
                        />
                      </v-col>
                      <v-col>
                        <v-img
                          contain
                          width="15vw"
                          src="@/assets/images/dashboard/media_aluno.png"
                        />
                      </v-col>
                      <v-col>
                        <v-img
                          contain
                          width="15vw"
                          src="@/assets/images/dashboard/ativos.png"
                        />
                      </v-col>
                      <v-col>
                        <v-img
                          contain
                          width="15vw"
                          src="@/assets/images/dashboard/conclusao.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="d-flex flex-column">
                        <v-img
                          contain
                          width="30vw"
                          src="@/assets/images/dashboard/dicas_ensino.png"
                        />
                        <v-img
                          contain
                          width="30vw"
                          src="@/assets/images/dashboard/engajamento.png"
                        />
                      </v-col>
                      <v-col class="d-flex flex-column">
                        <v-img
                          contain
                          width="30vw"
                          src="@/assets/images/dashboard/ingles_conosco.png"
                        />
                        <v-img
                          contain
                          width="30vw"
                          src="@/assets/images/dashboard/overview_aulas.png"
                        />
                        <v-img
                          contain
                          width="30vw"
                          src="@/assets/images/dashboard/atividades_curso.png"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card> </v-col></v-row></v-row
        ></v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "CustomerDashboard",
  created() {},
  computed: {
    customerName() {
      return this.$store.getters.getName.split(" ")[0];
    },
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>
<style lang="css" scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}
</style>
